import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {StandingsWidgetState} from "./models/standings-widget.state";
import {StandingsWidgetConfig} from "./standings-widget.config";

export class StandingsWidgetStore extends BaseMobxStore {
  static injectables = [StandingsWidgetConfig, StandingsWidgetState];
}
